import styled from 'styled-components';

import { A } from '@main/pc-core-components';
import { responsive, sp, timing } from '@main/theme';

/**
 * The FooterNav Wrapper
 */
export const FooterNavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  margin-top: ${sp(1)};

  ${responsive.atLeastTablet} {
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
  }

  ${responsive.atLeastDesktop} {
    flex-direction: row;
    align-items: center;
  }
`;

/**
 * Footer nav item
 */
export const FooterItem = styled.div`
  ${responsive.beforeTablet} {
    margin: 0 ${sp(0.75)} ${sp(1)} ${sp(0.75)};

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${responsive.justTablet} {
    margin-bottom: ${sp(0.5)};

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${responsive.atLeastDesktop} {
    margin-left: ${sp(3)};
  }
`;

/**
 * Footer wrapper props
 */
export interface FooterWrapperProps {
  /** Whether or not the footer is in the About Transcend page */
  transcend: string;
}

/**
 * The FooterNavLink Wrapper
 */
export const FooterNavLinkWrapper = styled(A)<FooterWrapperProps>`
  flex-grow: 1;
  white-space: nowrap;
  line-height: normal;
  letter-spacing: ${({ transcend }) =>
    transcend === 'true' ? '0.2px' : 'normal'};
  color: ${({ transcend, theme }) =>
    transcend === 'true' ? theme.colors.transcendNavy : ''};
  transition: all 0.3s;
  font-family: ${({ transcend, theme }) =>
    transcend === 'true'
      ? 'neue-haas-grotesk-display, sans-serif'
      : theme.textStyles.fontFamilyHeader.name};

  &:focus {
    box-shadow:
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 0 1px 3px,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 0 0 1px,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 2px 6px 0,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 1px 3.5px 0;
  }

  ${responsive.beforeTablet} {
    text-align: center;
  }
`;

/**
 * The Transcend Wrapper
 */
export const TranscendWrapper = styled.a<FooterWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: ${sp(1)};
  margin-left: 53px 0;
  border-radius: 4px;

  transition: all ${timing.short};

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    box-shadow:
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 0 1px 3px,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 0 0 1px,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 2px 6px 0,
      ${({ transcend, theme }) =>
          transcend === 'true'
            ? theme.colors.transcend
            : theme.colors.lightPrimary}
        0 1px 3.5px 0;
  }

  ${responsive.atLeastTablet} {
    margin: 0;
  }
`;

/**
 * The Footer wrapper
 */
export const FooterWrapper = styled.footer<FooterWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${sp(3)} 0 ${sp(4)} 0;
  background-color: ${({ theme }) => theme.colors.white};

  ${responsive.justTablet} {
    padding: ${({ transcend }) =>
      transcend === 'true' ? `${sp(1)} ${sp(4.5)}` : `${sp(2)} ${sp(4.5)}`};
    flex-direction: row;
    justify-content: space-between;
  }

  ${responsive.atLeastDesktop} {
    padding: ${sp(1)} ${sp(4)} ${sp(1)} ${sp(2)};
    flex-direction: row;
    justify-content: space-between;
  }
`;
